<template>
  <ElementFormItem
    :prop="inputKey"
    :rules="rules"
    :label="name"
    :error="customError"
    class="form-generator__content-item"
  >
    <StitchTooltip
      :message="disabledMessage"
      :is-disabled="!isDisabled"
    >
      <ElementDatePicker
        v-model="inputData"
        type="date"
        :placeholder="name"
        :picker-options="datePickerOptions"
        :disabled="isDisabled"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        class="form-generator__content-item-date-picker"
        @input="setData"
      />
    </StitchTooltip>
  </ElementFormItem>
</template>

<script>
// props, data, computed props, created, setData
import { InputMixin } from '../mixins/InputMixin.js'

export default {
  name: 'InputDate',

  mixins: [InputMixin],

  props: {
    customError: {
      type: String,
      required: false,
      default: null
    },
    defaultValue: {
      type: String,
      required: false,
      default: null
    }
  },

  data () {
    return {
      datePickerOptions: {
        /**
         * Disable any date before tomorrow.
         *
         * @param   {Date}    date - The date being evaluated by the picker.
         * @returns {boolean}      - `true` if the date should be disabled (i.e. is before tomorrow).
         */
        disabledDate (date) {
          const today = new Date()
          const tomorrow = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate() + 1
          )

          return date < tomorrow
        }
      }
    }
  },

  methods: {
    /**
     */
    initInput () {
      if (this.defaultValue === null) {
        this.inputData = null
      } else {
        this.inputData = this.defaultValue || ''
      }

      this.setData()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/utils';

.form-generator__text-input {
  min-width: $input-width;
}

.form-generator__content-item-date-picker {
  width: 100%;
}
</style>
